import { GRAPH_SCALES } from 'modules/liveLook/constants';

export const GET_SCALE_RANGE = {
  LAST_WEEK: GRAPH_SCALES.day,
  FOUR_WEEKS: GRAPH_SCALES.week,
  FOUR_MONTHS: GRAPH_SCALES.month,
};
